function isNull(value: unknown) {
  return value === null
}

export default isNull
